import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Features = () => {
    const { t } = useLanguage();

    const keyFeatures = [
        {
            title: t('features.list.aiSearch.title'),
            description: t('features.list.aiSearch.description'),
            icon: '🚀'
        },
        {
            title: t('features.list.cloudArch.title'),
            description: t('features.list.cloudArch.description'),
            icon: '☁️'
        },
        {
            title: t('features.list.integrations.title'),
            description: t('features.list.integrations.description'),
            icon: '🔗'
        },
        {
            title: t('features.list.analytics.title'),
            description: t('features.list.analytics.description'),
            icon: '📊'
        },
        {
            title: t('features.list.fieldFriendly.title'),
            description: t('features.list.fieldFriendly.description'),
            icon: '📱'
        }
    ];

    const styles = {
        section: {
            padding: '100px 32px',
            backgroundColor: '#F9F9F9',
        },
        container: {
            maxWidth: '1400px',
            margin: '0 auto',
        },
        h2: {
            fontSize: '48px',
            fontWeight: '800',
            marginBottom: '60px',
            textAlign: 'center',
            color: '#2B2B2B',
        },
        highlight: {
            color: '#3457D5',
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
            gap: '28px',
        },
        card: {
            backgroundColor: '#FFFFFF',
            padding: '36px',
            borderRadius: '20px',
            border: '1px solid #E5E5E5',
            display: 'flex',
            gap: '24px',
            alignItems: 'flex-start',
            transition: 'all 0.3s',
        },
        icon: {
            fontSize: '40px',
            flexShrink: 0,
        },
        content: {
            flex: 1,
        },
        cardTitle: {
            fontSize: '22px',
            fontWeight: '700',
            color: '#2B2B2B',
            marginBottom: '12px',
        },
        cardDesc: {
            fontSize: '16px',
            color: '#6E6E6E',
            lineHeight: '1.7',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.section.padding = '60px 20px';
        styles.h2.fontSize = '32px';
        styles.grid.gridTemplateColumns = '1fr';
    }

    return (
        <section style={styles.section} id="features">
            <div style={styles.container}>
                <h2 style={styles.h2}>
                    {t('features.title')}<span style={styles.highlight}>{t('features.titleHighlight')}</span>
                </h2>

                <div style={styles.grid}>
                    {keyFeatures.map((feature, index) => (
                        <div
                            key={index}
                            style={styles.card}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-4px)';
                                e.currentTarget.style.boxShadow = '0 15px 35px rgba(52,87,213,0.12)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <span style={styles.icon}>{feature.icon}</span>
                            <div style={styles.content}>
                                <h3 style={styles.cardTitle}>{feature.title}</h3>
                                <p style={styles.cardDesc}>{feature.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Features;
